import { render, staticRenderFns } from "./SimpleCategoryProducts/template.pug?vue&type=template&id=a1c81cf6&scoped=true&lang=pug&"
import script from "./InfiniteProductList.vue?vue&type=script&lang=js&"
export * from "./InfiniteProductList.vue?vue&type=script&lang=js&"
import style0 from "./InfiniteProductList.vue?vue&type=style&index=0&id=a1c81cf6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c81cf6",
  null
  
)

export default component.exports